const paths = {
  hubsList: '/hubs/list'
};

export default paths;
